import { useEffect, useRef } from "react";
import { api } from "../lib/api";

const sig = (e) => `${e.state}|${e.ticks}|${e.outcome}|${e.hedge ? e.hedge.ticks : ""}`;

// T50 Shadow Mode: every signal the chart engine produces is recorded (upserted) as a research row — behaves exactly
// like a live strategy, never executes. Batches every 10s; only rows whose state changed since the last upload.
export function useT50Shadow(symbol, tfId, t50, enabled = true) {
  const sent = useRef(new Map());
  const latest = useRef(null);
  latest.current = t50;
  useEffect(() => { sent.current = new Map(); }, [symbol, tfId]);
  useEffect(() => {
    if (!enabled) return undefined;
    const flush = async () => {
      const r = latest.current;
      if (!r?.events?.length) return;
      const rows = [];
      for (const e of r.events.slice(-300)) {
        if (!e.entryPrice) continue;
        const s = sig(e);
        if (sent.current.get(e.id) === s) continue;
        rows.push({ strategy: "T50", symbol, timeframe: tfId, direction: e.dir, state: e.state, threshold: e.threshold, bar1_time: e.bar1.time, bar2_time: e.bar2.time,
          entry_time: e.entryTime, entry_price: e.entryPrice, evaluation_ticks: e.ticks, mfe: e.mfe, mae: e.mae, mfe_tick: e.mfeTick, mae_tick: e.maeTick,
          target_results: e.targets, failure: e.failed, hedge_signal: e.hedge, outcome: e.outcome, payload: { bar1: e.bar1, bar2: e.bar2, closeLoc: e.closeLoc, window: r.config.window } });
        sent.current.set(e.id, s);
        if (rows.length >= 200) break;
      }
      if (!rows.length) return;
      try { await api.post("/strategy/events", rows); } catch { for (const row of rows) sent.current.delete(`t50-${row.bar2_time}-${row.direction}`); }
    };
    const id = setInterval(flush, 10000);
    const first = setTimeout(flush, 3000);
    return () => { clearInterval(id); clearTimeout(first); };
  }, [symbol, tfId, enabled]);
}
